const fadeSection = document.querySelector("[js-fade-section]");

if (fadeSection) {
  const navItems = fadeSection.querySelectorAll("[js-nav-item]");
  const featuredImage = fadeSection.querySelector("[js-featured-img] img");
  const featuredTitle = fadeSection.querySelector("[js-featured-title]");
  const featuredText = fadeSection.querySelector("[js-featured-text]");

  navItems.forEach((nav) => nav.addEventListener("click", updateSlide));

  function updateSlide() {
    fadeSection.classList.add("is-fading");
    navItems.forEach((nav) => nav.classList.remove("active"));
    this.classList.add("active");

    const src = this.getAttribute("data-src");
    const title = this.getAttribute("data-title");
    const text = this.getAttribute("data-text");

    setTimeout(function () {
      featuredImage.setAttribute("src", src);
      featuredImage.setAttribute("srcset", src);
      featuredTitle.innerText = title;
      featuredText.innerText = text;
    }, 300);
    setTimeout(function () {
      fadeSection.classList.remove("is-fading");
    }, 700);
  }
}
